import {Component} from '@angular/core';
import {Router} from '@angular/router';
import { AuthService } from '../../../../shared/services/auth/auth.service';
import { TwoFactorEnum } from '../../../settings/enum/settings-type.enum';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent {
  email: string = '';
  errorMessage: string = '';

  isSubmitted:boolean=false;
  showOtpForm:boolean=false;
  verificationType:TwoFactorEnum=TwoFactorEnum.email
  constructor(private readonly router: Router,
    private readonly authService:AuthService
  ) {
  }

  submitForm() {
    this.isSubmitted=true
    this.resendCode();
  }


  resendCode(){
    if(this.email?.trim()){
      this.authService.preForgetPassword(this.email).subscribe({
        next:(res)=>{
          if(res?.success){
            this.showOtpForm=true;
          }
        }
      })
    }
  }
  sendOtpCode(data:{code:string}){
    if(this.email?.trim()){
      this.authService.verifyForgetPassword({email:this.email,otpCode:data.code}).subscribe({
        next:(res)=>{
          if(res?.success){
            this.showOtpForm=false;
            this.router.navigate(['auth/forgot-password/reset-password'],{
              state:{email:this.email,otp:data.code}
            });
          }
        }
      })
    }
  }
  onGoBack(){
    this.showOtpForm=false;
  }
}
